var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "intro table-wrapper full-width hidden-table-sm box",
          staticStyle: { "border-spacing": "8px", position: "relative" },
        },
        [
          _c(
            "div",
            {
              staticClass: "col-md-4 table-cell sdr-box",
              class: {
                xflightIsNotRebookable: _vm.flight.rebookable === false,
              },
            },
            [
              _c("dl", { staticClass: "term-description" }, [
                _c("dt", [
                  _vm._v(_vm._s(_vm.airline[_vm.getCurrentLocale]) + ":"),
                ]),
                _c("dd", [_vm._v("FBR/Schauinsland")]),
                _vm._v(" "),
                _c("dt", [
                  _vm._v(_vm._s(_vm.flighttype[_vm.getCurrentLocale]) + ":"),
                ]),
                _c("dd", [_vm._v("Economy")]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-md-8 table-cell",
              class: {
                xflightIsNotRebookable: _vm.flight.rebookable === false,
              },
            },
            [
              _c("div", { staticClass: "detailed-features booking-details" }, [
                _c("div", { staticClass: "sdr-box" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button btn-mini yellow pull-right",
                      staticStyle: { cursor: "unset" },
                    },
                    [
                      _vm._v(
                        "STOPS: " +
                          _vm._s(_vm.flight.stopAirport === null ? "0" : "1")
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "box-title" }, [
                    _vm._v(
                      _vm._s(_vm.from[_vm.getCurrentLocale]) +
                        " " +
                        _vm._s(_vm.flight.departureAirport.location) +
                        " " +
                        _vm._s(_vm.to[_vm.getCurrentLocale]) +
                        "  " +
                        _vm._s(_vm.flight.destinationAirport.location)
                    ),
                    _c("small", [
                      _vm._v(_vm._s(_vm.outwardflight[_vm.getCurrentLocale])),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-wrapper flights" }, [
                  _c("div", { staticClass: "table-row first-flight" }, [
                    _c("div", { staticClass: "table-cell logo" }, [
                      _c("img", {
                        staticStyle: { "padding-bottom": "3px" },
                        attrs: { src: "/res/images/sdr140x30.png", alt: "" },
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v(_vm._s(_vm.flight.flightNo))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-cell timing-detail" }, [
                      _c("div", { staticClass: "timing" }, [
                        _c("div", { staticClass: "check-in" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale])),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFlightCart")(
                                  _vm.flight.departureDateTime
                                )
                              ) +
                                ", " +
                                _vm._s(
                                  _vm._f("momentTime")(
                                    _vm.flight.departureDateTime
                                  )
                                )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "duration text-center" }, [
                          _c("i", { staticClass: "soap-icon-clock" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("durationFlightCart")(
                                  _vm.flight.duration
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "check-out" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale])),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFlightCart")(
                                  _vm.flight.destinationDateTime
                                )
                              ) +
                                ", " +
                                _vm._s(
                                  _vm._f("momentTime")(
                                    _vm.flight.destinationDateTime
                                  )
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.flight.rebookable === false
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 table-cell",
                  staticStyle: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    "z-index": "10",
                    height: "100%",
                    background: "rgba(228, 226,226, .8)",
                  },
                },
                [
                  _c("p", { staticClass: "center" }, [
                    _vm._v(
                      _vm._s(_vm.notrebookableanymore[_vm.getCurrentLocale])
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("sdr-rebooking-bookingno-paxdetails", {
        attrs: {
          flight: _vm.flight,
          flightdirection: _vm.flightdirection,
          modulo: _vm.modulo,
          mode: _vm.mode,
          whichcall: _vm.whichcall,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }